import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {StudentInfoForm} from './StudentInfoForm.js';
import {StudentListTableRow} from './StudentListTableRow.js';

export class StudentListTable {
	constructor(parent, studentListModel, studentSelectModel) {
		[this.el, this.$] = DojoTemplates('StudentListTable2');
		this.model = studentListModel;
		this.model.added.add(this.studentAdded, this);
		this.selectModel = studentSelectModel;
		// console.log("StudentListTable :: this.$.table = " , this.$.table);
		parent.appendChild(this.el);
		this.infoForm = new StudentInfoForm(this.$.infoForm);
	}
	studentAdded(student, src) {
		new StudentListTableRow(this.$.table, student, this.model, 
			this.selectModel, this.infoForm);
	}
}